<template>
</template>
<script>
import Vue from 'vue';
import VueObserveVisibility from 'vue-observe-visibility';
import HomeBlock from '@/models/home-block';
import smoothscroll from 'smoothscroll-polyfill';
import homeUtils from '@/Utilities/homeUtils';

Vue.use(VueObserveVisibility);

export default {
    components:{
    },
    props:{
        config:{
            type: Array,
            default: () => {
                return []
            }
        },
        url:{
            type: String
        },
        isDesktop: {
            type: Boolean,
            default: true
        },
        relativeViewport: {
            type: Boolean,
            default: false
        },
        isHomepage:{
            type: Boolean,
            default: true
        }
    },
    data(){
        return{
            blocks: [],
            minHeight: 0
        }
    },
    created() {
        this.minHeight = this.isHomepage ? window.pageYOffset + homeUtils.getViewPortHeight() : 50;
        if(!window._blocksHandler){
            // this component can have multiple instances on the same page, 
            // set this "variable" to component's UID to prevent the same event hanlder multiple times
            window._blocksHandler = this._uid;
            window.addEventListener("resize", this.resize);
        }
    },
    destroyed() {
        if(window._blocksHandler == this._uid){
            // this is the component that added the event handler, removed it
            window.removeEventListener("resize", this.resize);
        }
    },
    mounted() {
        let bcs = [];
        if(this.url){
            homeUtils.requestUrl = this.url;
        }
        this.config.forEach( (e,i) => {
            let block = new HomeBlock(this.url,e,i);
            if(this.isHomepage){
                //Medium block
                if(i>=7 && (i % 2) == 0 && block.itensVp == 5 && block.type == 'NormalProducts'){
                    block.itensVp = 4;
                }
            }
            bcs.push(block);
        });
        this.blocks = bcs;
        smoothscroll.polyfill();
        if(window._blocksHandler == this._uid){
            // this is the component that added the event handler, calculate resize
            this.resize();
        }

        if(this.isHomepage){
            //Position on teh page
            setTimeout(() => {
                homeUtils.scrollPosition();
                homeUtils.removeAnchor();
            },500);
        }
    },
    methods: {
        resize(){
            homeUtils.setPropertyVW();
        }
    }
}
</script>